"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PARTICIPANT: 'participant',
    CREATOR: 'creator',
};
//# sourceMappingURL=bookingParticipantType.js.map